import { render, staticRenderFns } from "./ActionsDocument.vue?vue&type=template&id=361055c4&"
import script from "./ActionsDocument.vue?vue&type=script&lang=js&"
export * from "./ActionsDocument.vue?vue&type=script&lang=js&"
import style0 from "./ActionsDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports